import React from "react";
import styles from "./sixth.module.scss";
import IMG from "../../assets/images/home-sixth-section.png";
const Sixth = () => {
  return (
    <div className={styles.root}>
      <section className={styles.top}>
        <span className={styles.title}>
          How Does
          <span className="blue-text"> dVPN </span>
          Work?
        </span>
        <span className={styles.description}>
          The Sentinel back-end is a permissionless blockchain that records the
          usage of bandwidth and transfer of currency between nodes and users.
        </span>
      </section>
      <img src={IMG} alt="" />
    </div>
  );
};

export default Sixth;
